<template>
  <footer>
    <div class="row top">
      <div class="medium-5 small-12 columns">
        <router-link to="/" class="logo">
          <img src="../assets/images/ditaro_logo.png" alt="Spectrum">
        </router-link>
      </div>
      <div class="medium-7 small-12 columns">
        <ul>
          <li><a href="/#speed-test" v-smooth-scroll="{ duration: 1500 }">Speed Test</a></li>
          <li><a href="/#calculator" v-smooth-scroll="{ duration: 1500 }">Calculator</a></li>
          <li><router-link to="/help-center">Help Center</router-link></li>
          <li><a href @click.prevent="contactPopup = true">Contact</a></li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="medium-8 small-12 columns">
        <p class="meta">1245 E. Brickyard Rd, Suite 250 Salt Lake City, UT 84106 | Email: <a href="mailto:info@mytechamenity.com">Info@MyTechAmenity.com</a> | Phone:
          <a href="tel:8887846867">888 784 6867</a></p>
      </div>
      <div class="medium-4 small-12 columns">
        <p class="copyright">&copy; 2018 Ditaro LLC &nbsp; <!-- <a href @click.prevent="privacyPopup = true">Privacy</a> | <a href @click.prevent="termsPopup = true">Terms</a> --></p>
      </div>
    </div>
    
    <!-- Contact Modal -->
    <v-dialog v-model="contactPopup" width="1080">
      <div class="video-popup contact-popup">
        <v-btn fab small flat class="close-button" @click="contactPopup = false">
          <v-icon large>close</v-icon>
        </v-btn>
        <div class="row column">
          <h3>Contact Us</h3>
        </div>
        <form class="contact-form" action="#" v-on:submit.prevent>
          <div class="row collapse">
            <div class="medium-6 small-12 columns pad-right">
              <input type="text" name="first_name" id="first_name" placeholder="First Name">
            </div>
            <div class="medium-6 small-12 columns pad-left">
              <input type="text" name="last_name" id="last_name" placeholder="Last Name">
            </div>
            <div class="medium-6 small-12 columns pad-right">
              <input type="email" name="email" id="email" placeholder="Email">
            </div>
            <div class="medium-6 small-12 columns pad-left">
              <input type="text" name="phone" id="phone" placeholder="Phone">
            </div>
            <div class="small-12 columns">
              <input type="text" name="location" id="location" placeholder="Apartment">
              <textarea name="message" id="message" placeholder="How can we help you?" rows="10"></textarea>
            </div>
            <div>
              <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  :sitekey="sitekey">
              </vue-recaptcha>
            </div>
            <div class="small-12 columns">
              <div class="submit">
                <button class="button" @click.prevent='checkIfCaptchaVerified()'>Send</button>
              </div>
              <FlashMessage></FlashMessage>
            </div>
          </div>
        </form>
      </div>
    </v-dialog>
    
    <!-- Privacy Modal -->
    <v-dialog v-model="privacyPopup" width="1080">
      <div class="video-popup contact-popup">
        <v-btn fab small flat class="close-button" @click="privacyPopup = false">
          <v-icon large>close</v-icon>
        </v-btn>
        <div class="row column">
          <h3 class="mb-5">Privacy Policy</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae dolorem doloribus eaque enim eum facere impedit itaque iure maiores molestiae provident quisquam quo rem, repudiandae tempora, tempore veniam voluptatum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus dolorum impedit ipsum modi perspiciatis porro possimus quam. Ad aliquam amet consectetur consequuntur, dolore eaque fugiat ipsum, officia saepe, sit ut?</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae dolorem doloribus eaque enim eum facere impedit itaque iure maiores molestiae provident quisquam quo rem, repudiandae tempora, tempore veniam voluptatum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus dolorum impedit ipsum modi perspiciatis porro possimus quam. Ad aliquam amet consectetur consequuntur, dolore eaque fugiat ipsum, officia saepe, sit ut?</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae dolorem doloribus eaque enim eum facere impedit itaque iure maiores molestiae provident quisquam quo rem, repudiandae tempora, tempore veniam voluptatum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus dolorum impedit ipsum modi perspiciatis porro possimus quam. Ad aliquam amet consectetur consequuntur, dolore eaque fugiat ipsum, officia saepe, sit ut?</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae dolorem doloribus eaque enim eum facere impedit itaque iure maiores molestiae provident quisquam quo rem, repudiandae tempora, tempore veniam voluptatum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus dolorum impedit ipsum modi perspiciatis porro possimus quam. Ad aliquam amet consectetur consequuntur, dolore eaque fugiat ipsum, officia saepe, sit ut?</p>
        </div>
      </div>
    </v-dialog>

    <!-- Terms Modal -->
    <v-dialog v-model="termsPopup" width="1080">
      <div class="video-popup contact-popup">
        <v-btn fab small flat class="close-button" @click="termsPopup = false">
          <v-icon large>close</v-icon>
        </v-btn>
        <div class="row column">
          <h3 class="mb-5">Terms</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae dolorem doloribus eaque enim eum facere impedit itaque iure maiores molestiae provident quisquam quo rem, repudiandae tempora, tempore veniam voluptatum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus dolorum impedit ipsum modi perspiciatis porro possimus quam. Ad aliquam amet consectetur consequuntur, dolore eaque fugiat ipsum, officia saepe, sit ut?</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi beatae dolorem doloribus eaque enim eum facere impedit itaque iure maiores molestiae provident quisquam quo rem, repudiandae tempora, tempore veniam voluptatum. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus dolorum impedit ipsum modi perspiciatis porro possimus quam. Ad aliquam amet consectetur consequuntur, dolore eaque fugiat ipsum, officia saepe, sit ut?</p>
        </div>
      </div>
    </v-dialog>
    
  </footer>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  
  export default {
    name: 'Footer',

    components: { VueRecaptcha },

    data () {
      return {
        contactPopup: false,
        privacyPopup: false,
        termsPopup: false,
        sitekey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
        verifiedCaptcha: false
      }
    },
    
    mounted() {
      emailjs.init( process.env.VUE_APP_EMAIL_USER_ID );
    },

    methods: {
      checkIfCaptchaVerified: function() {
        if( !this.verifiedCaptcha ){
          this.flashMessage.error({
            title: 'Captcha Failed',
            message: 'Please verify the captcha',
            time: 3000
          });
        }
        else{
          this.sendContactFormEmail();
        }
      },
      
      onVerify: function ( response ) {
        this.verifiedCaptcha = true;
      },
      
      onExpired: function () {
        this.verifiedCaptcha = false;
      },
      
      sendContactFormEmail: function(){
        var firstName = document.getElementById( 'first_name' ).value;
        var lastName = document.getElementById( 'last_name' ).value;
        var email = document.getElementById( 'email' ).value;
        var phone = document.getElementById( 'phone' ).value;
        var message = document.getElementById( 'message' ).value;
        var apartment = document.getElementById( 'location' ).value;
        var property = window.location.hostname;
        
        if( firstName === '' || lastName === '' || email === '' || phone === '' || message === '' ){
          this.flashMessage.error({
            title: 'Missing Required Input',
            message: '"First Name", "Last Name", "Email", "Phone", and "Message" are Required',
            time: 3000
          });
        }
        else if( !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test( email ) ){
          this.flashMessage.error({
            title: 'Invalid Email',
            message: 'Please enter a valid email address',
            time: 3000
          });
        }
        else if( !/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test( phone ) ){
          this.flashMessage.error({
            title: 'Invalid Phone Number',
            message: 'Please enter a valid phone number',
            time: 3000
          });
        }
        else{
          var _this = this;
          
          emailjs.send('mailgun', 'user_submitted_contact_form', {
                "email": email,
                "first_name": firstName,
                "last_name": lastName,
                "property": property,
                "apartment": apartment,
                "phone": phone,
                "message": message
              })
              .then(function(response) {
                _this.flashMessage.success({
                  title: 'We Received Your Submission',
                  message: 'A confirmation email has been sent to you, we will respond to your request shortly',
                  time: 3000
                });
                
                setTimeout(function(){
                  window.location.reload()
                }, 3000 );
              }, function(error) {
                _this.flashMessage.error({
                  title: 'Something Went Wrong',
                  message: 'Please refresh your page and try again',
                  time: 3000
                });
              });
        }
      }
    }
  }
</script>
